import * as React from "react";

import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import ServerAPIClient, { JSONRPC, FetchTransport } from "dialup";
import { AdminAPIClient } from "dialup/ts/dist/admin_client"

import thunkMiddleware from "redux-thunk";

import { authStateChanged } from "./actions";
import APIClient from "./api/APIClient";
import RouterContainer from "./components/Router";
import { rootReducer } from "./reducers/rootReducer";
import { IExtra } from "./types";

let config = {
  apiKey: "AIzaSyAxHFrqDfRUuM-hZuBOKUf_5CGu39hXwg0",
  authDomain: "your-boss.firebaseapp.com",
  databaseURL: "https://your-boss.firebaseio.com",
  messagingSenderId: "421444783401",
  projectId: "your-boss",
  storageBucket: "your-boss.appspot.com",
};

const config64 = process.env.REACT_APP_FIREBASE_CONFIG;
if (config64) {
  config = JSON.parse(atob(config64));
}

const app = firebase.initializeApp(config);
if (!app) {
  alert("Failed to initialize firebase");
  throw new Error("Failed to initialize firebase");
}

const apiURL = process.env.REACT_APP_API_URL || "https://api.dialup.com";

const authFunc = async () => {
  if (!app.auth) {
    return "";
  }
  const user = app.auth().currentUser;
  if (!user) {
    return "";
  }
  const token = await user.getIdToken();
  return token;
};

const api = new APIClient(authFunc, apiURL);

const tx = new FetchTransport(apiURL + "/v2", async req => {
  const jwt = await authFunc();

  return {
    ...req,
    headers: {
      ...req.headers,
      Authorization: `Bearer ${jwt}`,
    }
  };
});
const jsonrpc = new JSONRPC(tx);
const adminRPC = new AdminAPIClient(jsonrpc);
const rpc = new ServerAPIClient(jsonrpc);

const extra: IExtra = {
  api,
  adminRPC,
  rpc,
  firebase: app,
};

const store = createStore(
  rootReducer,
  applyMiddleware(thunkMiddleware.withExtraArgument(extra))
);

if (app.auth) {
  store.dispatch(authStateChanged(app.auth().currentUser));
  app.auth().onAuthStateChanged(user => store.dispatch(authStateChanged(user)));
}

export default () => (
  <Provider store={store}>
    <RouterContainer />
  </Provider>
);



// WEBPACK FOOTER //
// ./src/App.tsx